import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MealReview from "../components/MealReview";
import { loadMealRemote, updateMealRemote } from "../lib/storage";
import type { LoggedMeal, MealEstimate, MealType } from "../lib/types";

export default function EditMeal() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [meal, setMeal] = useState<LoggedMeal | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    loadMealRemote(id)
      .then((m) => setMeal(m))
      .catch((e) => setError((e as Error)?.message ?? String(e)))
      .finally(() => setLoading(false));
  }, [id]);

  async function onConfirm(estimate: MealEstimate, mealType: MealType) {
    if (!id || !meal) return;
    try {
      await updateMealRemote(id, {
        meal_type: mealType,
        estimate,
        caption: meal.caption
      });
      navigate(-1);
    } catch (err) {
      setError((err as Error)?.message ?? String(err));
    }
  }

  if (loading) return <div className="p-8 text-center text-slate-500 text-sm">Loading…</div>;
  if (error) {
    return (
      <div className="p-4 space-y-3">
        <div className="p-3 rounded-lg bg-red-950 border border-red-800 text-red-200">{error}</div>
        <button onClick={() => navigate(-1)} className="w-full py-3 rounded-lg bg-slate-800 text-slate-100">
          Back
        </button>
      </div>
    );
  }
  if (!meal) {
    return (
      <div className="p-8 text-center text-slate-500 text-sm">
        Meal not found.
        <div>
          <button onClick={() => navigate("/")} className="text-emerald-400 underline mt-3">
            Back to Today
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-2">
      <div className="px-4 pt-2 pb-1 flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="text-sm text-slate-400">
          ← Back
        </button>
        <span className="text-sm text-slate-400">Editing meal</span>
      </div>
      <MealReview
        initial={meal.estimate}
        initialMealType={meal.meal_type}
        disagreementPct={meal.disagreement_pct ?? 0}
        onConfirm={onConfirm}
        onCancel={() => navigate(-1)}
      />
    </div>
  );
}
